import { Actions } from './colisLogistiqueActions';

/**
 * Etat initial
 */
const initialState = {
    colisLogistiques: {
        items: [],
        isLoading: false
    }
};

/**
 * Reducer pour les colis de pièce gestion
 */
const reducer = (state = initialState, action) => {

    switch (action.type) {
        // Fetch Piece gestion colis.
        case Actions.FETCH_COLIS_LOGISTIQUE_REQUEST:
            return {
                ...state,
                colisLogistiques: { ...state.colisLogistiques, isLoading: true }
            };
        case Actions.FETCH_COLIS_LOGISTIQUE_SUCCESS:
            return {
                ...state,
                colisLogistiques: { items: [...action.colisLogistiques], isLoading: false }
            };
        case Actions.FETCH_COLIS_LOGISTIQUE_FAILURE:
            return {
                ...state,
                colisLogistiques: { ...state.colisLogistiques, isLoading: false, error: action.error }
            }

        case Actions.CLEAR_COLIS_LOGISTIQUE:
            {
                return {
                    ...state,
                    colisLogistiques: {
                        ...state.colisLogistiques,
                        items: []
                    }
                };
            }

        default:
            return state;
    }
}

export default reducer;